import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import BaseSwitch from "@reusables/BaseSwitch";
import { DefaultsFormTyping } from "../types";

export default function AllowNegativeStockSetting() {
    const { t } = useTranslation("", {
        keyPrefix: "settings.general.defaults.settings.negativeStock",
    });

    const { control } = useFormContext<DefaultsFormTyping>();

    return (
        <div className="flex flex-row items-center justify-between p-3 gap-4 bg-[#F9F9F9] border-1 border-solid border-[#D9D6DA] rounded-md">
            <div className="flex flex-col gap-2">
                <div className="text-accent">{t("label")}</div>
                <div className="text-sm text-gray-500">{t("description")}</div>
            </div>
            <div>
                <Controller
                    name="allow_negative_stock"
                    control={control}
                    render={({ field }) => (
                        <BaseSwitch
                            checked={field.value}
                            onChange={(_, checked) => field.onChange(checked)}
                        />
                    )}
                />
            </div>
        </div>
    );
}
